import Textfield from "../Input/Textfield";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Modal, { ModalProps } from "../Modal/Modal";
import { useModalMeta } from "@/shared/atoms/useModal";
import Button from "../Button/Button";
import { formatDate } from "@/shared/utils/helpers";
import useFlyerReorderPost from "@/shared/mutations/flyer/useFlyerReorderPost";

const ReorderFlyerModal = ({ onExit, ...props }: ModalProps) => {
  const { t } = useTranslation();
  const [{ externalId }] = useModalMeta();
  const reorder = useFlyerReorderPost();

  const { register, errors, handleSubmit } = useForm();

  const onSubmit = (data) => {
    reorder
      .mutateAsync({
        flyerId: externalId,
        body: t("flyer.mailBody", {
          quantity: data.quantity,
          externalId: externalId,
          date: data.date,
        }),
      })
      .then(() => onExit());
  };

  return (
    <Modal onExit={onExit} {...props}>
      <form
        className="flex flex-col gap-4"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Textfield
          label={t("flyer.quantity")}
          ref={register({
            required: {
              value: true,
              message: t("fieldRequired"),
            },
          })}
          error={errors.order_user?.house_number?.message}
          type="number"
          name="quantity"
        />
        <Textfield
          label={t("flyer.desiredDeliveryDate")}
          defaultValue={formatDate(new Date(), "inputDate")}
          type="date"
          ref={register({
            required: {
              value: true,
              message: t("fieldRequired"),
            },
          })}
          min={formatDate(new Date(), "inputDate")}
          name="date"
        />

        <Button type="submit" isPending={reorder.isPending}>
          {t("save")}
        </Button>
      </form>
    </Modal>
  );
};

export default ReorderFlyerModal;
